// extracted by mini-css-extract-plugin
export default {"root":"SuccessCard_root__hn6ax","submitButton":"SuccessCard_submitButton__utudH"};